import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogingService {
  appInsights: ApplicationInsights;
  private isInitialPageLoad: boolean = true;
  constructor(private router: Router) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.instrumentationKey,
        enableAutoRouteTracking: false,
      }
    });
    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer((envelope) => {
        let itemTags = envelope.tags;
        if (itemTags) {
            itemTags = itemTags || [];
            itemTags['ai.cloud.role'] = environment.applicationFullName;
        }
    });

    this.trackViews();
  }
  

  trackViews() {
    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((event: NavigationStart) => {
      if (!this.isInitialPageLoad)
        this.appInsights.startTrackPage(event.url);
      else
        this.isInitialPageLoad = false;
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (!this.isInitialPageLoad)
        this.appInsights.stopTrackPage(event.urlAfterRedirects);
      else
        this.isInitialPageLoad = false;
    });

    if (this.isInitialPageLoad) {
      this.logPageView(this.router.url);
    }
  }

  addUserEmail(email: string){
    this.appInsights.addTelemetryInitializer((envelope) => {
      var item = envelope.baseData;
      item.properties = item.properties || {};
      item.properties["UserEmail"] = email;
    });
  }

  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message}, properties);
  }
}